// extracted by mini-css-extract-plugin
export default {"main":"RouteCard_main__w-OE9","image":"RouteCard_image__IUqDe"};